import {AxiosResponse} from "axios";

import BaseService from "./base.service";

export default class MasterMessengerService extends BaseService {
    constructor() {
        super(process.env.REACT_APP_SERVICE_BASE_PATH_MA_MASTER_MESSENGER || '');
    }
    public registerToTopic(token: string, topicName: string):Promise<AxiosResponse> {
        const body = {
            "tokens": [
              token
            ],
            "topics": [
              topicName
            ]
        }

        return this.httpPost("/v1/transport/subscribe", body)
    }
}
